module.exports = __webpack_public_path__ + "img/login-bj-ys1.7787a3a7.png";